import { DirectiveOptions } from 'vue';

/** Emission d'un évènement vers un composant */
var emit = (vnode, name, data) => {
	var handlers = (vnode.data && vnode.data.on) ||
	  (vnode.componentOptions && vnode.componentOptions.listeners);
  
	if (handlers && handlers[name]) {
	  handlers[name].fns(data);
	}
  }

/** v-columnsresizable est une directive permettant la gestion du redimenssionnement d'une colonne.
    Inspirée du composant vue-columns-resizable mais qui n'était pas compatible avec le composant vuedraggable.
	Il a été réimplémenté en directive custom à partir de https://github.com/Fuxy526/vue-columns-resizable/issues/3 
	en complétant avec la possibilité de redimenssionner sur de nouvelles colonnes ajoutées */
	const columnsresizable: DirectiveOptions = {
		inserted (el: any, binding, vnode) {
			if (el.nodeName !== 'TABLE' && el.nodeName !== 'TH') { return console.error('This directive is only valid on a table or a th element !'); }
			
			const opt: any = binding.value || {};
			let table: any;
			let thead: any;
			let ths:any;
			if (el.nodeName === 'TH')
			{
				let th: any = el;
				thead = th.closest('thead');
				table = thead.closest('table');
				ths = Array.from(thead.querySelectorAll('th'));

				// Suppression des div de resize existants qui vont être recréés plus bas (pour compabilité si on ajoute une nouvelle colonne dynamiquement)
				const divs:any = thead.querySelectorAll('div .columns-resize-bar');
				divs.forEach((div) => {
					div.remove();
				});
			}
			else if (el.nodeName === 'TABLE')
			{
				table = el;
				thead = table.querySelector('thead');
				ths = Array.from(thead.querySelectorAll('th'));
			}
			
			const calcTableWidth = () => {
				let tableWidth = 0;
				let width = 0;

				ths.forEach((th) => {
					if (th.style.width) {
						width = Number(parseInt(th.style.width));
					} else {
						width = th.offsetWidth;
					}
					tableWidth += width;
				}, 0);
				return tableWidth;
			};
			const applyTableWidth = () => {
				if (opt.fixedWidthTable) {
					table.style.width = calcTableWidth().toString();
					table.style.maxWidth = 'none';
				} else if (!table.style.width) {
					table.style.width = '100%';
					table.style.maxWidth = '100%';
				}
			};
			const handleResize = e => {
				if (opt.resizable === false) return;

				if (!opt.fixedWidthTable) {
					activeTh.style.width = parseInt(activeTh.style.width) + e.movementX + 'px';
					//neighbourghTh.style.width = parseInt(neighbourghTh.style.width) - e.movementX + 'px';
				} else {
					activeTh.style.width = parseInt(activeTh.style.width) + e.movementX + 'px';
					table.style.width = parseInt(table.style.width) + e.movementX + 'px';
				}
			};

			let activeTh: any = null; // the th being resized
			let neighbourghTh:any = null; // the next except when the last column is being resized in that case it is the previous
			let resizing:any = false; // a resize started needed because we can not detect event handler was attached or not
			table.style.position = 'relative';

			applyTableWidth();

			 ths.forEach((th, index) => {
			// for(var index = 0; index < ths.length; index++){
			// 	var th = ths[index];
				//console.debug("columnsresizable - th : " + th.style.width);
				// initialise the width if th does not already have it
				if (!th.style.width) {
					th.style.width = th.offsetWidth + 'px';
				}

				th.originalWidth = th.style.width;
				const bar = document.createElement('div');
				
				bar.style.position = 'absolute';
				bar.style.right = '0';
				bar.style.top = '0';
				bar.style.bottom = '0';
				bar.style.cursor = 'col-resize';

				// customisable options
				bar.style.width = opt.handleWidth || '8px';
				bar.style.zIndex = opt.zIndex || 1;
				bar.className = opt.handleClass || 'columns-resize-bar';

				bar.addEventListener('mousedown', (e: any) => {
					// element with a fixedsize attribute will be ignored
					if (e.target.parentElement.getAttribute('fixedsize')) {
						return;
					}
					resizing = true;
					
					// Empêche les autres listener de perturber le resize
					//e.stopPropagation();
					e.preventDefault();
					document.body.addEventListener('mousemove', handleResize);
					document.body.style.cursor = 'col-resize';
					document.body.style.userSelect = 'none';

					activeTh = e.target.parentElement;
					neighbourghTh = activeTh.nextElementSibling;
					if (!neighbourghTh) {
						neighbourghTh = activeTh.previousElementSibling;
					}

					// calculate table size if the table width is fixed
					if (!opt.fixedWidthTable) {
						let tableWidth = ths.reduce((a, th) => {
							return a + Number(parseInt(th.style.width));
						}, 0);
						table.style.width = tableWidth + 'px';
					}
				});
				
				// Emet un event de fin de resize (utilisé dans le composant utilisateur de cette directive pour enregistrer la taille des colonnes quand le bouton de souris est relaché)
				bar.addEventListener('mouseup',  (e: any) => {
					activeTh = e.target.parentElement;
					let width = 0;
					if (activeTh.style.width)
						width = Number(parseInt(activeTh.style.width));
					else
						width = activeTh.offsetWidth;

					// Emet un event de fin de resize (utilisé dans le composant utilisateur de cette directive pour enregistrer la taille des colonnes)
					emit(vnode, 'columnResized' , { 
						name: activeTh.getAttribute('data-headername'), width: width 
					});

					//neighbourghTh = activeTh.nextElementSibling;
				});

				th.appendChild(bar);
			});

			document.addEventListener('mouseup', () => {
				if (!resizing) return;
				resizing = false;
				document.body.removeEventListener('mousemove', handleResize);
				// Réactive les autres listener

				document.body.style.cursor = '';
				document.body.style.userSelect = '';
				if (typeof opt.afterResize === 'function') {
					opt.afterResize(ths);
				}
			});

			// resets the column sizes
			el.$resetColumnSizes = () => {
				ths.forEach((th) => {
					th.style.width = th.originalWidth;
				}, 0);
				applyTableWidth();
			};
		}
		// ,
		// update (el: any, binding) {
		// 	console.debug("columnsresizable - update() : el.nodeName : " + el.nodeName + ' - binding.value : ' + binding.value) ;
		// },
		// componentUpdated (el: any, binding) {
		// 	console.debug("columnsresizable - componentUpdated() : el.nodeName : " + el.nodeName + ' - binding.value : ' + binding.value) ;
	};

export default columnsresizable;